import React from 'react'
import * as Icons from '@desenvolvimento-intuix/ui-icons'

// eslint-disable-next-line no-unused-vars
import { ILoading } from '../../interfaces/loading'

import { Container } from './styles'

export const Loading: React.FC<ILoading> = ({ children, loader }) => {
  return (
    <Container>
      <i>
        <Icons.Loader color={loader?.color} />
      </i>

      {children}
    </Container>
  )
}
